const normalizeAmount = (value, previousValue) => {
    if (!value) {
        return value
    }
    const onlyNums = value.replace(/[^\d.]/g, '')

    if (onlyNums === '')
        return onlyNums;
    else
        return "$" + onlyNums;
}

export default normalizeAmount